import React from 'react'
import clsx from 'clsx';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'
import { BsX } from 'react-icons/bs'
import './styles.css'

const NoAuthModal = (props) => {
  const openRegistrationHandler = () => {
    if (window.in_native_app && window.platform === 'android') {
      window.ReactNativeWebView.postMessage(JSON.stringify({
				type: 'OPEN_REGISTRATION',
			}))

      return
    }

    props.changeToRegister()
  }

  if (!props.shouldExpand) {
    return (
      <div
        className='fixed z-30 w-full max-w-md no-expanded-login-modal'
        style={{
          height: '9rem',
          bottom: window.native_app_navigation_bar_height ?? 0,
        }}
      >
        <div className='w-full h-full relative'>
          <div className='absolute w-full bottom-6 right-6 flex flex-row justify-end items-center text-yellow'>
            <button className='cursor-pointer underline text-xl font-bold mr-2' onClick={props.changeToLogin}>
              Entre
            </button>
            
            <span className='text-xl font-bold mr-2'>ou</span>
            
            <button className='cursor-pointer mr-6 underline text-xl font-bold' onClick={openRegistrationHandler}>
              Assine
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={clsx(
        "fixed left-0 bottom-0 p-4 w-full transition-colors duration-300 h-full z-50 bg-black-60 flex flex-row justify-center items-center",
      )}
    >
      <div className={clsx('w-full mx-auto relative max-w-md px-12 py-8 rounded-3xl bg-white flex flex-col justify-center items-center',)}>
        <button className='absolute top-4 right-4 cursor-pointer' onClick={props.closeExpanded}>
          <BsX className='w-9 h-9 text-blue-primary' />
        </button>

        <img src={LogoPng} alt='Dum Dum' className='w-48 h-14' />

        <p className='mt-8 mb-16 leading-tight text-xl text-center font-bold text-blue-primary'>Entre ou faça uma assinatura para ter este e outros livros na sua biblioteca e ler quando quiser.</p>

        <button
          className='w-full py-2 rounded-full flex flex-row justify-center items-center bg-amber-300 text-blue-primary font-bold text-sm'
          onClick={() => {
            props.changeToLogin()
            props.closeExpanded()
          }}
        >
          Entrar
        </button>
        
        <button
          className='w-full py-2 rounded-full flex flex-row justify-center items-center bg-blue-primary text-white mt-2 font-bold text-sm'
          onClick={() => {
            openRegistrationHandler()
            props.closeExpanded()
          }}
        >
          Assinar
        </button>
      </div>
    </div>
  )
}

export default NoAuthModal
